import { Task } from '../../types';
import { TaskMode } from '../../taskTypes/module';
import { deriveTaskMode } from '../../domain/taskPolicy';

export interface DeriveModeContext {
  uid: string | null;
  task: Task | null;
  canReview: boolean;
}

export interface DeriveModeResult {
  mode: TaskMode;
  /** Reviewer has not claimed yet but is eligible to pick up the task. */
  canClaimReview: boolean;
}

export function deriveMode({ uid, task, canReview }: DeriveModeContext): DeriveModeResult {
  return deriveTaskMode({ uid, task, canReview });
}
